import type {
  GetToolResultRequest,
  GetToolResultResponse,
  StartSessionRequest,
  StartSessionResponse,
  StopFormulationResponse,
  AgentMessageResponse,
  GetUserTaskResponse,
  FormulationRequest,
  UploadUserContextResponse,
  ExtractProcessTableRequest,
  ExtractProcessTableResponse,
  AllSearchSourceItem,
} from '@/types/formulation/formulation';
import type { PsHttpSSE } from '@patsnap-utils/sse';

export const MaterialFormulationApi = Symbol('MaterialFormulationApi');

export interface MaterialFormulationApi {
  getToolResult(data: GetToolResultRequest): Promise<GetToolResultResponse>;

  /** POST /formulation/sessions - create a new formulation session (v4 API) */
  startSession(request: StartSessionRequest): Promise<StartSessionResponse>;

  /** POST /formulation/sessions/{session_id}/stop - cancel running formulation task (v4 API) */
  stopSession(sessionId: string): Promise<StopFormulationResponse>;

  /** GET /agent-messages/ - list agent messages for a session (v4 API) */
  listAgentMessages(sessionId: string): Promise<AgentMessageResponse[]>;

  /** GET /agent-messages/{agent_message_id} - get a single agent message (v4 API) */
  getAgentMessage(agentMessageId: number, sessionId: string): Promise<AgentMessageResponse>;

  /** GET /agent-messages/leastSearchDoc/{agent_message_id} - get a single agent message with least search doc (v4 API) */
  getLeastSearchDocAgentMessage(
    agentMessageId: number,
    sessionId: string,
  ): Promise<AgentMessageResponse>;

  /** GET /agent-messages/all-search-sources - get search sources for a session iteration (v4 API) */
  getAllSearchSources(sessionId: string, iteration: number): Promise<AllSearchSourceItem[]>;

  /** GET /user-tasks/ - get user task for a session (v4 API) */
  getUserTask(sessionId: string): Promise<GetUserTaskResponse>;

  /** POST /formulation/sessions/{session_id} - run formulation agent, returns SSE stream (v4 API) */
  formulate(sessionId: string, request: FormulationRequest): PsHttpSSE<string>;

  /** POST /user-context/upload - upload excel file for user context */
  uploadUserContext(file: File): Promise<UploadUserContextResponse>;

  /** POST /formulation/sessions/{session_id}/extract-process-table - get process table for a source */
  getExtractProcessTable(
    sessionId: string,
    request: ExtractProcessTableRequest,
  ): Promise<ExtractProcessTableResponse>;

  /** POST /user-tasks/share - share a user task */
  handleShare(sessionId: string): Promise<Record<string, unknown>>;

  /** POST /user-tasks/share-email - share a user task via email */
  shareEmail(sessionId: string, shareEmail: string): Promise<Record<string, unknown>>;
}
